import { useEffect } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { PageType } from '@vgtv/api-client/lib/page';
import type { CnpTag } from '@vgtv/api-client/lib/cnp_tag';

import { PageComponents } from '../components/PageComponents/PageComponents';
import { PageMetadata } from '../components/PageMetadata/PageMetadata';
import { pageStartsWithSplash } from '../shared/helpers/pageHelpers';
import { PageHeaderSplash } from '../components/PageHeaderSplash/PageHeaderSplash';
import { getPath, routeNames } from '../shared/helpers/routes';
import { PageSpinner } from '../components/PageSpinner/PageSpinner';
import { usePageViewTracking } from '../components/utils/usePageViewTracking';
import { replaceUrl } from '../helpers/replaceUrl';
import { config } from '../config';

import { usePageConfig } from './usePageConfig';
import { NotFoundPage } from './NotFoundPage';

function TagPage() {
  const { tagId } = useParams<{ tagId: CnpTag['id'] }>();

  const { pageConfig, isFetching, isFetched } = usePageConfig({
    identifier: tagId,
    pageType: PageType.TAG,
    vendor: config.provider,
  });

  const history = useHistory();

  useEffect(() => {
    if (pageConfig && pageConfig.tag) {
      const { id: tagId, title } = pageConfig.tag;

      replaceUrl(history, getPath(routeNames.tag, { tagId, title }));
    }
  }, [pageConfig, history]);

  usePageViewTracking({
    pageType: PageType.TAG,
    entity: pageConfig ? pageConfig.tag : undefined,
  });

  if (!pageConfig) {
    if (isFetching) {
      return <PageSpinner />;
    }

    if (!isFetching && isFetched) {
      return <NotFoundPage />;
    }

    return null;
  }

  const { components } = pageConfig;

  const startsWithSplash = pageStartsWithSplash(pageConfig);

  return (
    <>
      <PageMetadata
        entity={pageConfig.tag}
        pageType={PageType.TAG}
        overrides={pageConfig.meta}
      />
      {!startsWithSplash && <PageHeaderSplash pageConfiguration={pageConfig} />}
      <PageComponents componentsConfig={components} />
    </>
  );
}

export { TagPage };
